import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { LayoutService } from '../../services/layout.service';
import { APP_VERSION_LABEL } from '../../../config/app-version';
import { ReleaseNotesService } from '../../../versioning';

@Component({
  selector: 'app-version-bar',
  imports: [MatIconModule],
  templateUrl: './version-bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionBar {
  private readonly layoutService = inject(LayoutService);
  private readonly router = inject(Router);
  private readonly releaseNotes = inject(ReleaseNotesService);

  readonly versionLabel = APP_VERSION_LABEL;
  readonly isOffline = this.layoutService.isOffline;
  readonly hasUnread = this.releaseNotes.hasUnread;

  abrirNovidades(): void {
    this.router.navigate(['/novidades']);
  }
}
